import { Box } from "@chakra-ui/react";
import { HStack, LargeButton, LARGEL_BUTTON_TYPE, Spinner, useResponsive } from "goi_common";

export default function RequestCompareSubmitButton({
  handleSubmit,
  loading,
  disabled,
}: {
  handleSubmit: () => void;
  loading: boolean;
  disabled: boolean;
}) {
  const { isBiggerThanMd } = useResponsive();
  return (
    <HStack
      position="fixed"
      style={{
        bottom: 0,
        marginTop: "110px",
      }}
      width={isBiggerThanMd ? "480px" : "100%"}
      maxWidth={isBiggerThanMd ? "var(--global-max-width)" : "480px"}
    >
      <LargeButton
        buttonType={disabled ? LARGEL_BUTTON_TYPE.DISABLED : LARGEL_BUTTON_TYPE.PRIMARY}
        disabled={disabled}
        borderRadius={0}
        height={60}
        onClick={handleSubmit}
      >
        <Box display="flex">{loading ? <Spinner /> : "내 상조 상품, 거품이 없는지 알아보기"}</Box>
      </LargeButton>
    </HStack>
  );
}
